module.exports = __webpack_public_path__ + "img/Warehouse-Shippinglabel.91459c01.jpg";